import { useCreateWorkOrderWithTasks } from '@ztechapps/work-order.common'
import { useHistory } from '@ztechapps/common.hook'
import type { RouteDef, WorkOrder } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import type { WorkOrderAddFormValues } from './Context'

export const useWorkOrderAdd = () => {
  const [onAdd, { error, loading }] = useCreateWorkOrderWithTasks()
  const history = useHistory()
  const workOrderItemRoute = useInject<RouteDef>(WebuiIocKey.routes.workOrderItem)

  const onSubmit = async ({ product, quantity }: WorkOrderAddFormValues): Promise<void> => {
    const input = {
      product: {
        _id: product?._id,
      },
      quantity,
    } as WorkOrder
    const workOrder = await onAdd({ workOrder: input })

    // if then navigate to necessary field is no error then navigate to
    const route = workOrderItemRoute.altPath({
      _id: workOrder?._id,
    })

    history.push(route)
  }

  return { onSubmit, error, loading }
}
